module.exports = __webpack_public_path__ + "img/erb-md.e4c695d9.jpg";